const readJson = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const errorId = payload.errorId ? ` (Error ${payload.errorId})` : '';
    throw new Error(`${payload.message || 'The set gallery could not be loaded.'}${errorId}`);
  }
  return payload;
};

export const listPublicSets = ({ page = 1, sort = 'newest', search = '' } = {}, signal) => {
  const query = new URLSearchParams({ page: String(page), sort });
  if (search) query.set('search', search);
  return fetch(`/api/sets/list_public_sets.php?${query}`, {
    credentials: 'same-origin',
    signal,
  }).then(readJson);
};

